import React, { SetStateAction, Dispatch } from "react";

export type TOverlaySubject = 'welcome' | 'sales' | 'production' | 'warehousing';

interface IOverlaySubjectContext {
    subject?: TOverlaySubject,
    setSubject: Dispatch<SetStateAction<TOverlaySubject | undefined>>
}

export const OverlaySubjectContext = React.createContext<IOverlaySubjectContext>({
    setSubject: () => {}
});
